import React from "react";

import { ErrorModal, LoadingModal } from "components";
import { useCheckTransitionsProvider } from "hooks";

export type CheckTransitionsContextValue = ReturnType<typeof useCheckTransitionsProvider>;

export const CheckTransitionsContext = React.createContext<CheckTransitionsContextValue>({
  isLoading: true,
  isError: false,
  intervalReload: () => Promise.resolve(),
});

export const CheckTransitionsProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const value = useCheckTransitionsProvider();

  return (
    <CheckTransitionsContext.Provider value={value}>
      {children}
      <ErrorModal open={value.isError} />
      <LoadingModal open={value.isLoading} />
    </CheckTransitionsContext.Provider>
  );
};
